
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Hotel/[hotelSlug]/[locale]",
      function () {
        return require("private-next-pages/Hotel/[hotelSlug]/[locale].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Hotel/[hotelSlug]/[locale]"])
      });
    }
  